<ul class="container">
    @for (option of options; track $index) {
        <li class="option">
            <a [href]="option.link.href">
                <sirius-icon class="sir-icon" [name]="option.icon"></sirius-icon>
                <span>
                    {{ option.link.title }}
                    <sirius-icon class="sir-icon show-only-on-hover" [name]="'arrow_right'"></sirius-icon>
                </span>
            </a>
        </li>
    }
</ul>
